import { HIGHEST_GAINER, HIGHEST_GAINER_STREAM, } from "../../../interface/drivingMarket/HighestGainer/iHighestGainer";
import { drivingMarketOptionsStream } from "@domains/features/Markets/Options/utils/streamUpdate";
let initState = {
    data: {},
};
const HighestGainer = (state = initState, action) => {
    switch (action.type) {
        case HIGHEST_GAINER:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case HIGHEST_GAINER_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketOptionsStream(state.data, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default HighestGainer;
